export default __webpack_public_path__ + "static/media/user_dashboard_7.ac152d8c.jpeg";